export interface PutAnswer {
  AnswerValue: string;
  AnswerID: string;
  QuestionID: string;
}
